import { FC } from 'react';
import { TaskStatus } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import { CheckListPopoverFilterSelector } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { FilterIcon } from '../../atoms/filter-icon';
import { useTaskStatusFilterData } from './use-task-status-filter-data';

export const TaskStatusFilterChip: FC<{ disabled?: boolean; trackingId?: string }> = ({ disabled, trackingId }) => {
  const { value: selectedValues, defaultValue, taskStatusOptions, isLoading, onChange } = useTaskStatusFilterData();
  const { t } = useTranslation('call-intelligence');

  return (
    <CheckListPopoverFilterSelector<TaskStatus>
      defaultValue={defaultValue}
      disabled={disabled || isLoading}
      highlightEmptyOnOpen
      label={t('Status')}
      onChange={onChange}
      options={taskStatusOptions}
      renderIcon={(isFilterActive, isOpen) => (
        <FilterIcon name={!isOpen ? 'task-small' : 'pending-small'} isFilterActive={isFilterActive} />
      )}
      value={selectedValues}
      trackingId={trackingId}
    />
  );
};
